import { useState } from 'react';
import { useIntl } from 'react-intl';
import { POIBrandsModal, ScreensCartographyModal } from 'sonata-platform-components';

import { useMultiFlightMap } from '@/components/common/MultiFlightMap/MultiFlightMap.context';
import { useModals } from '@/router';

type State = {
  showCartographyModal: boolean;
  tagFilters: Record<string, string[]>;
  bulkIds: string[];
};

export default function PoiFinderModal() {
  const { addSourcesAsScreens, countries, entityId, sources, temporaryVenues, venuesSourceData, user, userRoles } =
    useMultiFlightMap();
  const { formatMessage } = useIntl();
  const modals = useModals();

  const [{ showCartographyModal, tagFilters, bulkIds }, setState] = useState<State>({
    bulkIds: [],
    showCartographyModal: false,
    tagFilters: {}
  });

  const handleModalSave = (countryCode: string, itemsToSave: Record<string, any>) => {
    const [[, items]] = Object.entries(itemsToSave);
    const itemsWithCountry = items.map((item: Record<string, any>) => ({
      ...item,
      country: item.country ?? countryCode
    }));
    addSourcesAsScreens(itemsWithCountry);
    modals.close();
  };

  const handleCartographyReset = () => {
    setState(prev => ({ ...prev, bulkIds: [], tagFilters: {} }));
  };

  const handleCartographySave = (newTagFilters: Record<string, string[]>, newBulkIds: string[]) => {
    setState(prev => ({
      ...prev,
      bulkIds: newBulkIds,
      showCartographyModal: false,
      tagFilters: newTagFilters
    }));
  };

  const mergedOriginFilters = {
    layerIsochroneFilter: {},
    poiFilters: {},
    tagFilters,
    ...(bulkIds.length > 0 && {
      sourceFilters: { device_id: bulkIds }
    })
  };

  return (
    <>
      <POIBrandsModal
        campaign={{ _id: entityId }}
        countries={countries.map(c => c.toLocaleUpperCase())}
        description={formatMessage({
          defaultMessage: 'Search & select your screens from our library',
          id: 'poiBrandsModal.screensDescription'
        })}
        filterAddedShops={temporaryVenues.filter(v => !v.deleted && v._id).map(v => v._id!)}
        includeMyVenuesSource
        isModalOpened
        onAdminBoundariesClick={() => setState(prev => ({ ...prev, showCartographyModal: true }))}
        onAdminBoundariesReset={handleCartographyReset}
        onModalClose={() => modals.close()}
        onModalSave={handleModalSave}
        origin="screens"
        originFilters={mergedOriginFilters}
        shouldFeatureAddFromCampaign={false}
        shouldHideSourceTypeSelector
        sources={sources.allSources}
        theme="light"
        title={formatMessage({
          defaultMessage: 'Add screens to map',
          id: 'poiBrandsModal.screensTitle'
        })}
        user={user}
        userRoles={userRoles}
        venuesSourceData={venuesSourceData}
        viewport={{}}
      />
      {showCartographyModal && (
        <ScreensCartographyModal
          countries={countries.map(c => c.toLocaleUpperCase())}
          initialBulkIds={bulkIds}
          initialTagFilters={tagFilters}
          isModalOpened={showCartographyModal}
          onClose={() => setState(prev => ({ ...prev, showCartographyModal: false }))}
          onSave={handleCartographySave}
          user={user}
          userRoles={userRoles}
        />
      )}
    </>
  );
}
